"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textError = exports.textLinkDefault = exports.textLinkActive = exports.grayBackground = exports.errorLight = exports.successGlobal = exports.successNeutral = exports.lightWeightBlue = exports.successLight = exports.infoLight = exports.warningLight = exports.chartDefault = exports.background02 = exports.background01 = exports.brandOrange = exports.white = exports.tableauGray14 = exports.tableauGray13 = exports.tableauGray12 = exports.tableauGray11 = exports.tableauGray10 = exports.tableauGray09 = exports.tableauGray08 = exports.tableauGray07 = exports.tableauGray06 = exports.tableauGray05 = exports.tableauGray04 = exports.tableauGray03 = exports.tableauGray02 = exports.tableauGray01 = exports.lightGray = exports.veryLightGray = exports.lightBlue = exports.lightGreen = exports.lightRed = exports.green = exports.teal = exports.red = exports.orange = exports.black = exports.defaultBlue = void 0;
exports.defaultBlue = '#4E79A7';
exports.black = 'black';
exports.orange = '#F28E2B';
exports.red = '#FF0000';
exports.teal = '#76B7B2';
exports.green = '#009900';
exports.lightRed = '#FCD8D7';
exports.lightGreen = '#D1EDCB';
exports.lightBlue = '#46a0dc';
exports.veryLightGray = '#F2F2F2';
exports.lightGray = '#C1C1C1'; // Not in UX, replace later?
exports.tableauGray01 = '#ffffff';
exports.tableauGray02 = '#fafafa';
exports.tableauGray03 = '#F5F5F5';
exports.tableauGray04 = '#EBEBEB';
exports.tableauGray05 = '#E6E6E6';
exports.tableauGray06 = '#E1E1E1';
exports.tableauGray07 = '#d4d4d4';
exports.tableauGray08 = '#cbcbcb';
exports.tableauGray09 = '#BFBFBF';
exports.tableauGray10 = '#858585';
exports.tableauGray11 = '#666666';
exports.tableauGray12 = '#4f4f4f';
exports.tableauGray13 = '#333333';
exports.tableauGray14 = '#000000';
exports.white = '#ffffff';
exports.brandOrange = '#E8762C';
exports.background01 = '#AFA3C9';
exports.background02 = '#70A8BD';
exports.chartDefault = '#CBB3DE';
exports.warningLight = '#FEF9EF';
exports.infoLight = '#eef5f9';
exports.successLight = '#f2f8f6';
exports.lightWeightBlue = '#23608F';
exports.successNeutral = '#ace5c8';
exports.successGlobal = '#008057';
exports.errorLight = '#f9ebec';
exports.grayBackground = '#f1f1f1';
exports.textLinkActive = '#15557f';
exports.textLinkDefault = '#1a699e';
exports.textError = '#c93a47';
//# sourceMappingURL=colors.js.map